module.exports = __webpack_public_path__ + "media/images/favicon-2418d8a60a8f71180d275142a0a25a6c.png";